
/**
 * @export
 * @enum {string}
 */
export enum UserSortField {
    ID = 'ID',
    FIRST_NAME = 'FIRST_NAME',
    LAST_NAME = 'LAST_NAME',
    EMAIL = 'EMAIL',
    ACCOUNT_NAME = 'ACCOUNT_NAME',
    GROUP_NAME = 'GROUP_NAME',
    NEWSLETTERS = 'NEWSLETTERS',
    LAST_PLATFORM_ACTIVITY = 'LAST_PLATFORM_ACTIVITY',
    LAST_MOBILE_ACTIVITY = 'LAST_MOBILE_ACTIVITY',
    TYPE = 'TYPE',
    STATUS = 'STATUS',
    DELETED = 'DELETED',
    ADDRESS_1 = 'ADDRESS_1',
    ADDRESS_2 = 'ADDRESS_2',
    WORK_PHONE = 'WORK_PHONE',
    MOBILE_PHONE = 'MOBILE_PHONE',
    JOB_TITLE = 'JOB_TITLE',
    CITY = 'CITY',
    COUNTRY = 'COUNTRY',
    STATE = 'STATE',
    PROVINCE = 'PROVINCE',
    POSTAL_CODE = 'POSTAL_CODE',
    SAVED_SEARCHES = 'SAVED_SEARCHES',
    FIRST_LICENSED = 'FIRST_LICENSED',
    TEMPLATE_USER = 'TEMPLATE_USER',
    ACCOUNT_TEAM_MEMBER = 'ACCOUNT_TEAM_MEMBER',
    CREATOR = 'CREATOR',
    CREATED_DATE = 'CREATED_DATE',
    LAST_MODIFIER = 'LAST_MODIFIER',
    LAST_MODIFIED_DATE = 'LAST_MODIFIED_DATE',
    LAST_MODIFICATION_REASON = 'LAST_MODIFICATION_REASON',
    SALESFORCE_ID = 'SALESFORCE_ID',
    MS_DYNAMICS_ID = 'MS_DYNAMICS_ID',
    DEAL_CLOUD_ID = 'DEAL_CLOUD_ID',
    HUBSPOT_ID = 'HUBSPOT_ID'
}